import * as yup from 'yup';

export default yup.object({
    title: yup
        .string()
        .trim('Title must be a trimmed string')
        .required('Title is a required field')
        .strict()
});
